import { DrawerService, Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { DrawerName } from '../../drawer/constants';
import { isLogin } from '@src/js/common/utils';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

@Feature()
export class InsertAnimationFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    public constructor(private readonly drawerService: DrawerService) {
        super();
    }

    public handleAnimationOpen() {
        if (this.getRightSideBarManager()?.isAnimationEditorShown) {
            if (this.drawerService.isRightOpening(DrawerName.ANIMATION_RIGHT_DRAWER)) {
                return;
            }
            // case: 刷新页面后，侧边栏还未初始化时点击动画按钮，导致isAnimationEditorShown始终为true，侧边栏初始化后也无法触发打开逻辑
            this.getRightSideBarManager()?.setIsAnimationEditorShown(false);
        }
        this.callback();
    }

    public isHistoryShown() {
        return this.getAppService().editableServiceLayer?.historyManager.isShown();
    }

    protected getCustomDisabledState(): boolean {
        const { pptEditorState } = this.getUserPriviledgeService();
        return this.shouldDisableInMaster(config.id) || (pptEditorState !== PPTEditorStateType.EDITABLE)
            || (!isLogin() && !ENV.IS_LOCAL_EDIT) || !!this.isHistoryShown();
    }

    private getRightSideBarManager(): IRightSideBarManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.rightSideBarManager;
    }
}
